import { forwardRef } from 'react';
function forwardName(name, render) {
  render.displayName = name;
  render.__KONTUR_REACT_UI__ = name;
  return render;
}
export function forwardRefAndName(name, render) {
  return forwardName(name, /*#__PURE__*/
  forwardRef(render));
}
function forwardIconName(name, render) {
  render.displayName = name;
  render.__KONTUR_REACT_UI__ = name;
  render.__KONTUR_ICON__ = true;
  return render;
}
export function forwardRefAndIconName(name, render) {
  return forwardIconName(name, /*#__PURE__*/forwardRef(render));
}